module.exports = __webpack_public_path__ + "static/media/img-3.87416cce.png";